import {createRoot} from 'react-dom/client'
import {QueryClient, QueryClientProvider} from 'react-query'
import {ReactQueryDevtools} from 'react-query/devtools'
import {McpI18nProvider} from './_mcp/i18n/Mcpi18n'

import './_mcp/assets/sass/style.scss'
import './_mcp/assets/sass/plugins.scss'
import './_mcp/assets/sass/style.react.scss'
import {AppRoutes} from './app/routing/AppRoutes'
import {AuthProvider, setupAxios} from './app/modules/auth'
import axios from 'axios'

setupAxios(axios)

const queryClient = new QueryClient()
const container = document.getElementById('root')
if (container) {
  createRoot(container).render(
    <QueryClientProvider client={queryClient}>
      <McpI18nProvider>
        <AuthProvider>
          <AppRoutes />
        </AuthProvider>
      </McpI18nProvider>
      <ReactQueryDevtools initialIsOpen={false} />
    </QueryClientProvider>
  )
}
